/* class CustomAlertStore {
  message = null;
  onClose = null;

  show(message, onClose) {
    this.message = message;
    this.onClose = onClose;
  }

  clear() {
    this.message = null;
    if (this.onClose) this.onClose();
  }
}

export default new CustomAlertStore(); */

class CustomAlertStore {
  alert = null; // { message, type }
  subscribers = [];

  show(message, type = "info") {
    this.alert = { message, type };
    this.notify();
  }

  clear() {
    this.alert = null;
    this.notify();
  }

  subscribe(fn) {
    this.subscribers.push(fn);
    return () => {
      this.subscribers = this.subscribers.filter((sub) => sub !== fn);
    };
  }

  notify() {
    this.subscribers.forEach((fn) => fn(this.alert));
  }
}

export default new CustomAlertStore();
